import { useEffect, useState } from "react";

const MASSAGE_OFFERS = [
  {
    title: "Massage relaxant",
    description: "Détente absolue pour relâcher les tensions et retrouver la sérénité.",
    image: "https://cdn.pixabay.com/photo/2017/08/06/09/53/spa-2596895_1280.jpg",
    alt: "Massage relaxant sur table avec bougies et fleurs",
  },
  {
    title: "Massage sportif",
    description: "Favorise la récupération musculaire et améliore la souplesse.",
    image: "https://cdn.pixabay.com/photo/2017/09/04/09/35/massage-2717431_1280.jpg",
    alt: "Masseur étirant la jambe d'un sportif",
  },
  {
    title: "Aux huiles essentielles",
    description: "Un rituel parfumé et apaisant pour un esprit calme et un corps léger.",
    image: "https://cdn.pixabay.com/photo/2015/03/14/20/05/aromatherapy-673580_1280.jpg",
    alt: "Flacons d'huiles essentielles et serviettes",
  },
  {
    title: "Massage thaïlandais",
    description: "Technique énergétique et étirements profonds pour revitaliser le corps.",
    image: "https://cdn.pixabay.com/photo/2016/11/29/05/08/massage-1865684_1280.jpg",
    alt: "Stretching inspiré du massage thaï",
  },
  {
    title: "Pierres chaudes",
    description: "La chaleur des pierres volcaniques apaise les muscles et l’esprit.",
    image: "https://cdn.pixabay.com/photo/2016/03/27/18/38/hot-stones-1284461_1280.jpg",
    alt: "Pierres chaudes alignées sur le dos",
  },
];

const RECIPE_IDEAS = [
  {
    title: "Salade de quinoa",
    description: "Fraîche, croquante, prête en 15 min.",
    image:
      "https://images.unsplash.com/photo-1565958011705-44e211f932b6?auto=format&fit=crop&w=1200&q=80",
    alt: "Bol de salade de quinoa colorée",
  },
  {
    title: "Poulet rôti",
    description: "Peau croustillante, chair juteuse, zéro stress.",
    image:
      "https://images.unsplash.com/photo-1601050690597-3d1f0b6d13c4?auto=format&fit=crop&w=1200&q=80",
    alt: "Poulet rôti doré dans un plat",
  },
  {
    title: "Pâtes crémeuses",
    description: "Crémeux, parfumé, réconfortant.",
    image:
      "https://images.unsplash.com/photo-1627308595229-7830a5c91f9f?auto=format&fit=crop&w=1200&q=80",
    alt: "Assiette de pâtes crémeuses",
  },
];

const COOKIE_STORAGE_KEY = "youware-cookie-consent";

type ConsentChoice = "accepted" | "denied" | null;

function App() {
  const [consentChoice, setConsentChoice] = useState<ConsentChoice>(null);
  const [showCookiePanel, setShowCookiePanel] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_STORAGE_KEY);
    if (stored === "accepted" || stored === "denied") {
      setConsentChoice(stored);
      setShowCookiePanel(false);
    } else {
      setShowCookiePanel(true);
    }
  }, []);

  const handleConsent = (choice: Exclude<ConsentChoice, null>) => {
    localStorage.setItem(COOKIE_STORAGE_KEY, choice);
    setConsentChoice(choice);
    setShowCookiePanel(false);
  };

  const handleCustomize = () => {
    alert("Page de personnalisation (à implémenter selon vos besoins).");
  };

  const reopenCookiePanel = () => {
    setShowCookiePanel(true);
    if (consentChoice !== null) {
      setConsentChoice(consentChoice);
    }
  };

  return (
    <div className="min-h-screen bg-[#f6f1e8] text-[#1f1b16]">
        <header className="sticky top-0 z-40 border-b border-white/70 bg-[#fff9f1]/70 backdrop-blur-md">
          <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-5">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-2xl bg-gradient-to-br from-[#f9d77f] via-[#f3b34c] to-[#d8892d] shadow-[0_10px_30px_rgba(243,179,76,0.45)]" />
              <div className="leading-tight">
                <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#d8892d]">
                  Rituel &amp; Saveurs
                </p>
                <p className="text-lg font-semibold">Évasion maison</p>
              </div>
            </div>
            <nav className="hidden gap-8 text-sm font-semibold text-[#4b4035] md:flex">
              <a className="transition hover:text-[#d8892d]" href="#massages">
                Massages
              </a>
              <a className="transition hover:text-[#d8892d]" href="#recettes">
                Recettes
              </a>
              <a className="transition hover:text-[#d8892d]" href="#experience">
                Expérience
              </a>
            </nav>
            <button
              onClick={reopenCookiePanel}
              className="inline-flex items-center gap-2 rounded-full border border-[#d8892d]/40 bg-white/80 px-4 py-2 text-sm font-semibold text-[#d8892d] shadow-sm transition hover:-translate-y-0.5 hover:shadow-lg"
            >
              Gérer les cookies
            </button>
          </div>
        </header>

      <main>
        <section className="relative mx-auto mt-12 max-w-6xl overflow-hidden rounded-[32px] border border-white/60 bg-[#0e0b09] text-white shadow-[0_40px_90px_rgba(14,11,9,0.4)]">
          <img
            src="https://cdn.pixabay.com/photo/2017/08/06/09/53/spa-2596895_1280.jpg"
            alt="Salle de massage tamisée"
            className="absolute inset-0 h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-black/75 via-black/55 to-black/35" />
          <div className="relative z-10 px-6 py-20 sm:px-12 sm:py-24">
            <div className="mx-auto max-w-3xl text-center">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-medium uppercase tracking-[0.28em] text-[#f9d77f]">
                Maison &amp; spa
              </span>
              <h1 className="mt-6 text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl">
                Le duo bien-être &amp; cuisine qui transforme votre week-end
              </h1>
              <p className="mt-4 text-base text-white/80 sm:text-lg">
                Une parenthèse chaleureuse qui marie massages enveloppants et cuisine du cœur. Créez votre rituel sensoriel sans quitter la maison.
              </p>
              <div className="mt-10 flex flex-wrap justify-center gap-4">
                <a
                  href="#massages"
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-[#f3b34c] px-6 py-3 text-base font-semibold text-[#1f1308] shadow-[0_20px_40px_rgba(243,179,76,0.35)] transition hover:-translate-y-0.5 hover:shadow-[0_25px_55px_rgba(243,179,76,0.45)]"
                >
                  Explorer les soins
                </a>
                <a
                  href="#recettes"
                  className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 bg-white/10 px-6 py-3 text-base font-semibold text-white transition hover:-translate-y-0.5 hover:border-white/70 hover:bg-white/20"
                >
                  Voir les recettes
                </a>
              </div>
            </div>
            <div className="mt-16 grid gap-6 sm:grid-cols-3">
              <div className="rounded-2xl bg-white/10 p-6 text-left shadow-inner backdrop-blur-sm">
                <p className="text-sm uppercase tracking-[0.2em] text-[#f9d77f]">Temps pour soi</p>
                <p className="mt-3 text-2xl font-semibold">90 min de massage à domicile</p>
              </div>
              <div className="rounded-2xl bg-white/10 p-6 text-left shadow-inner backdrop-blur-sm">
                <p className="text-sm uppercase tracking-[0.2em] text-[#f9d77f]">Saveurs</p>
                <p className="mt-3 text-2xl font-semibold">3 recettes légères &amp; réconfortantes</p>
              </div>
              <div className="rounded-2xl bg-white/10 p-6 text-left shadow-inner backdrop-blur-sm">
                <p className="text-sm uppercase tracking-[0.2em] text-[#f9d77f]">Ambiance</p>
                <p className="mt-3 text-2xl font-semibold">Playlist et huiles sélectionnées</p>
              </div>
            </div>
          </div>
        </section>

        <section id="massages" className="mx-auto mt-20 max-w-6xl px-6">
          <div className="rounded-[32px] border border-white/70 bg-white/85 p-10 shadow-[0_35px_80px_rgba(26,17,7,0.08)] backdrop-blur-sm">
            <div className="max-w-3xl">
              <h2 className="text-3xl font-semibold tracking-tight text-[#1f1b16] sm:text-4xl">
                Massages signature pour relâcher tout le corps
              </h2>
              <p className="mt-4 text-base text-[#4b4035] sm:text-lg">
                Chaque soin s’inspire de techniques reconnues pour apaiser les tensions, stimuler l’énergie et installer une sérénité durable.
              </p>
            </div>
            <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
              {MASSAGE_OFFERS.map((offer) => (
                <article
                  key={offer.title}
                  className="group flex h-full flex-col overflow-hidden rounded-3xl border border-[#f3ebdf] bg-white shadow-[0_20px_60px_rgba(17,12,9,0.08)] transition hover:-translate-y-1 hover:shadow-[0_30px_80px_rgba(17,12,9,0.12)]"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={offer.image}
                      alt={offer.alt}
                      className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                    />
                    <span className="absolute left-5 top-5 inline-flex items-center rounded-full bg-white/85 px-3 py-1 text-xs font-semibold uppercase tracking-[0.25em] text-[#c2812d]">
                      Soin
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col gap-3 px-6 py-7">
                    <h3 className="text-xl font-semibold text-[#1f1b16]">{offer.title}</h3>
                    <p className="text-sm leading-relaxed text-[#6d5c4a]">{offer.description}</p>
                    <div className="mt-auto inline-flex items-center gap-2 text-sm font-semibold text-[#d8892d]">
                      Réserver ce massage
                      <span aria-hidden="true">→</span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section
          id="experience"
          className="relative mx-auto mt-24 flex max-w-6xl flex-col overflow-hidden rounded-[32px] border border-white/70 bg-[#211811] text-white shadow-[0_40px_90px_rgba(21,12,3,0.4)] lg:flex-row"
        >
          <div className="relative flex-1 p-10 sm:p-12">
            <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/60 to-transparent" />
            <img
              src="https://cdn.pixabay.com/photo/2016/11/29/03/53/spa-1865676_1280.jpg"
              alt="Bougies allumées sur un plateau de spa"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="relative z-10 max-w-lg">
              <span className="inline-flex items-center rounded-full bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.25em] text-[#f9d77f]">
                Ambiance
              </span>
              <h2 className="mt-6 text-3xl font-semibold leading-tight sm:text-4xl">
                Préparez le décor, nous apportons le rituel complet
              </h2>
              <ul className="mt-6 space-y-4 text-sm text-white/80 sm:text-base">
                <li>• Playlist relaxante pour orchestrer la séance.</li>
                <li>• Guide imprimable pour marier massage et dégustation.</li>
                <li>• Astuces pour prolonger l’énergie douce toute la semaine.</li>
              </ul>
            </div>
          </div>
          <div className="flex flex-1 flex-col justify-center gap-8 bg-white/95 p-8 text-[#1f1b16] sm:p-12">
            <div>
              <span className="inline-flex items-center rounded-full bg-[#f3b34c]/15 px-3 py-1 text-xs font-semibold uppercase tracking-[0.25em] text-[#d8892d]">
                Programme
              </span>
              <h3 className="mt-5 text-2xl font-semibold text-[#1f1b16]">
                Trois étapes pour se ressourcer à deux
              </h3>
              <ol className="mt-5 space-y-4 text-sm text-[#554839] sm:text-base">
                <li>
                  <strong className="font-semibold text-[#1f1b16]">1. Préparez l’espace :</strong> diffuseur d’huiles, lumières tamisées, serviettes chaudes.
                </li>
                <li>
                  <strong className="font-semibold text-[#1f1b16]">2. Massage guidé :</strong> suivez nos gestes illustrés pour un soin fluide et enveloppant.
                </li>
                <li>
                  <strong className="font-semibold text-[#1f1b16]">3. Pause gourmande :</strong> servez l’une des recettes légères pour prolonger la détente.
                </li>
              </ol>
            </div>
            <div className="rounded-3xl border border-[#f3b34c]/40 bg-[#fff8ed] p-6">
              <p className="text-sm uppercase tracking-[0.28em] text-[#d8892d]">Inclus</p>
              <p className="mt-3 text-lg font-semibold text-[#1f1b16]">E-book + playlist envoyés dès la réservation</p>
              <p className="mt-2 text-sm text-[#6d5c4a]">
                Recevez les liens de préparation et les recettes détaillées pour une expérience cohérente dès le premier rendez-vous.
              </p>
            </div>
          </div>
        </section>

        <section id="recettes" className="mx-auto mt-24 max-w-6xl px-6">
          <div className="grid gap-12 lg:grid-cols-[1.2fr_0.8fr]">
            <div>
              <h2 className="text-3xl font-semibold tracking-tight text-[#1f1b16] sm:text-4xl">
                Recettes légères à savourer après le soin
              </h2>
              <p className="mt-4 text-base text-[#4b4035] sm:text-lg">
                Ces plats rapides complètent le massage avec des saveurs lumineuses qui prolongent la sensation de confort.
              </p>
              <div className="mt-10 space-y-6">
                {RECIPE_IDEAS.map((recipe) => (
                  <article
                    key={recipe.title}
                    className="flex gap-6 rounded-3xl border border-[#f3ebdf] bg-white/95 p-4 shadow-[0_15px_50px_rgba(27,17,8,0.08)] transition hover:-translate-y-1 hover:shadow-[0_25px_70px_rgba(27,17,8,0.12)] sm:p-6"
                  >
                    <div className="h-32 w-32 overflow-hidden rounded-2xl">
                      <img src={recipe.image} alt={recipe.alt} className="h-full w-full object-cover" />
                    </div>
                    <div className="flex flex-1 flex-col justify-center gap-3">
                      <h3 className="text-xl font-semibold text-[#1f1b16]">{recipe.title}</h3>
                      <p className="text-sm text-[#6d5c4a]">{recipe.description}</p>
                      <button className="w-fit rounded-full border border-[#d8892d]/40 bg-[#f3b34c]/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.25em] text-[#d8892d] transition hover:bg-[#f3b34c]/20">
                        Télécharger la fiche
                      </button>
                    </div>
                  </article>
                ))}
              </div>
            </div>
            <div className="relative overflow-hidden rounded-[32px] border border-white/70 bg-[#1f1b16] text-white shadow-[0_35px_80px_rgba(17,12,9,0.35)]">
              <img
                src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=1200&q=80"
                alt="Table dressée avec plats maison"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-black/75 via-black/55 to-transparent" />
              <div className="relative z-10 flex h-full flex-col justify-end gap-6 p-10">
                <span className="inline-flex w-fit items-center rounded-full bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.28em] text-[#f9d77f]">
                  Table d'hôte
                </span>
                <p className="text-2xl font-semibold leading-tight sm:text-3xl">
                  Servez un repas qui prolonge la douceur du massage et invite au partage.
                </p>
                <p className="text-sm text-white/80">
                  Astuce : préparez les ingrédients avant la séance pour profiter de la soirée sans quitter votre bulle.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto mt-24 max-w-6xl px-6 pb-24">
          <div className="flex flex-col items-center gap-6 rounded-[32px] border border-white/70 bg-white/90 px-8 py-14 text-center shadow-[0_40px_90px_rgba(21,12,3,0.12)]">
            <span className="inline-flex items-center rounded-full bg-[#f3b34c]/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.25em] text-[#d8892d]">
              Offres limitées
            </span>
            <h2 className="max-w-3xl text-3xl font-semibold text-[#1f1b16] sm:text-4xl">
              Réservez votre rituel maison pour offrir une parenthèse sensorielle mémorable
            </h2>
            <p className="max-w-2xl text-base text-[#4b4035] sm:text-lg">
              Réservez une date, recevez le guide complet et profitez du moment : nous orchestrons le soin, vous dégustez la suite.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="#massages"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#f3b34c] px-6 py-3 text-base font-semibold text-[#1f1308] shadow-[0_20px_40px_rgba(243,179,76,0.35)] transition hover:-translate-y-0.5 hover:shadow-[0_25px_55px_rgba(243,179,76,0.45)]"
              >
                Réserver maintenant
              </a>
              <a
                href="#recettes"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-[#d8892d]/40 bg-white px-6 py-3 text-base font-semibold text-[#d8892d] shadow-sm transition hover:-translate-y-0.5 hover:shadow-lg"
              >
                Voir le guide
              </a>
            </div>
          </div>
        </section>
      </main>

        <footer className="border-t border-white/70 bg-[#fff9f1]/80 py-10 text-sm text-[#6d5c4a]">
          <div className="mx-auto flex max-w-6xl flex-col gap-4 px-6 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
            <p>© {new Date().getFullYear()} Rituel &amp; Saveurs. Tous droits réservés.</p>
            <div className="flex flex-wrap justify-center gap-4 sm:justify-end">
              <a className="transition hover:text-[#d8892d]" href="#">Politique de confidentialité</a>
              <a className="transition hover:text-[#d8892d]" href="#">Mentions légales</a>
            </div>
          </div>
        </footer>

        {showCookiePanel && (
          <div className="animate-fade-in fixed inset-0 z-[999] grid place-items-center bg-black/70 px-5 backdrop-blur-sm">
            <div className="cookie-card relative w-full max-w-xl overflow-hidden rounded-3xl border border-white/80 bg-white/95 p-8 text-center text-[#1f1b16] shadow-[0_45px_120px_rgba(0,0,0,0.35)]">
              <div className="relative z-10 flex flex-col gap-6">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-[#f9d77f] via-[#f3b34c] to-[#d8892d] text-white shadow-[0_15px_40px_rgba(243,179,76,0.45)]">
                  🍪
                </div>
                <div>
                  <h2 className="text-2xl font-semibold">Consentement aux cookies</h2>
                  <p className="mt-3 text-sm text-[#6d5c4a]">
                    Nous utilisons des cookies essentiels au fonctionnement du site et des cookies optionnels pour personnaliser l’expérience. Ajoutez votre préférence.
                  </p>
                </div>
                <div className="flex flex-wrap justify-center gap-3 font-semibold">
                  <button
                    onClick={() => handleConsent("denied")}
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-[#c2553a] px-5 py-3 text-sm text-white shadow-[0_15px_40px_rgba(194,85,58,0.35)] transition hover:-translate-y-0.5 hover:shadow-[0_20px_55px_rgba(194,85,58,0.45)]"
                  >
                    Tout refuser
                  </button>
                  <button
                    onClick={handleCustomize}
                    className="inline-flex items-center justify-center gap-2 rounded-full border border-[#d8892d]/40 bg-white px-5 py-3 text-sm text-[#d8892d] shadow-sm transition hover:-translate-y-0.5 hover:shadow-lg"
                  >
                    Personnaliser
                  </button>
                  <button
                    onClick={() => handleConsent("accepted")}
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-[#12a150] px-5 py-3 text-sm text-white shadow-[0_20px_50px_rgba(18,161,80,0.35)] transition hover:-translate-y-0.5 hover:shadow-[0_25px_70px_rgba(18,161,80,0.45)]"
                  >
                    Tout accepter
                  </button>
                </div>
                <p className="text-xs text-[#9b8472]">
                  En savoir plus : <a className="underline underline-offset-4" href="#">Politique de cookies</a>
                </p>
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

export default App;
